import scores from "../../api/scores";

const errors = {
    GET_ALL_STUDIES_LOADING_ERROR: 'Erreur lors du chargement des questionnaires, merci de réessayer',
    GET_ACTIVE_STUDIES_LOADING_ERROR: 'Erreur lors du chargement des questionnaires, merci de réessayer',
    GET_ALL_SCORES_LOADING_ERROR: 'Erreur lors du chargement des scores, merci de réessayer',
    GET_STUDY_LOADING_ERROR: 'Erreur lors du chargement du questionnaire, merci de réessayer',
    CREATE_STUDY_ERROR: 'Erreur lors de la création du questionnaire, merci de réessayer',
    UPDATE_STUDY_ERROR: 'Erreur lors de la mise à jour du questionnaire, merci de réessayer',
    STUDY_EXPORT_LOADING_ERROR: 'Erreur lors de l\'export du questionnaire, merci de réessayer',
}

const TYPES = {
    PUNCTUAL: 'punctual',
    STUDY: 'study'
}

const success = {
    CREATE_STUDY_SUCCESS: {
        title: "Succès",
        content: "Questionnaire créée avec succès"
    },
    UPDATE_STUDY_SUCCESS: {
        title: "Succès",
        content: "Questionnaire mise à jour"
    }
}

const CONCERNS = {
    PATIENT: 'patient',
    DOCTOR: 'doctor',
    BOTH: 'patient-doctor'
}


// initial state
const state = {
    currentLanguage: 'fr',
    scores: [],
    punctual_scores: [],
    active_punctual_scores: [],
    selected_score: {
        id: null,
        name: null,
        instructions: null,
        status: null,
        type: TYPES.PUNCTUAL,
        rule: null,
        extra: null,
        is_opposite: false,
        groups: [
            {
                id: null,
                name: null,
                instructions: null,
                rule: null,
                extra: null,
                position: null,
                concern: CONCERNS.PATIENT,
                number_questions: null,
                questions: []
            }
        ]
    },
    selected_group: {
        id: null,
        name: null,
        instructions: null,
        rule: null,
        extra: null,
        position: null,
        concern: CONCERNS.PATIENT,
        questions: [{
            id: null,
            text: null,
            position: null,
            special_type: null,
            answers: [
                {
                    id: null,
                    text: null,
                    remarks: null,
                    position: null,
                    value: null,
                }
            ]
        }],
        can: {
            delete: false
        }
    },
    form: {
        name: '',
        nameOriginal: '',
        instructions: null,
        instructionsOriginal: '',
        type: TYPES.PUNCTUAL,
        rule: 'sum',
        extra: null,
        is_opposite: false,
        can: {
            delete: false
        }
    },

    form_group: {
        name: '',
        nameOriginal: '',
        instructions: null,
        instructionsOriginal: null,
        rule: 'sum',
        extra: null,
        position: 1,
        concern: CONCERNS.PATIENT,
        questions: [],
    },

    form_question: {
        text: '',
        textOriginal: '',
        position: 1,
        special_type: null,
        answers: [],
        can: {
            delete: true
        }
    },

    form_answer: {
        text: '',
        textOriginal: '',
        remarks: null,
        remarksOriginal: '',
        position: 1,
        value: null,
        can: {
            delete: true
        }
    }
}

// getters
const getters = {
    getRuleLabels() {
        return [
            {value: 'sum', text: "Somme"},
            {value: 'list', text: "Liste"},
            {value: 'percent', text: "Pourcentage"},
            {value: 'percent_inverted', text: "Pourcentage inversé"},
            {value: 'percent_group', text: "Pourcentage par groupe"},
        ]
    },

    getSpecialTypeLabels() {
        return [
            {value: null, text: "Standard"},
            {value: 'scale', text: "Echelle"},
            {value: 'scale_custom', text: "Echelle centrée sans label"},
        ]
    },

    getTypeLabels() {
        return [
            {value: TYPES.PUNCTUAL, text: "Questionnaire ponctuel"},
            {value: TYPES.STUDY, text: "Etude clinique"},
        ]

    }
}

// actions
const actions = {
    getScoreInfo ({state, commit, rootState }) {
        scores.getScoreById(state.selected_score.id, rootState.axios).then(result => {
            commit('setSelectedScore', result.data.score)
        }).catch(reason => {
            commit('notifications/showError', {
                title: errors.GET_STUDY_LOADING_ERROR, content: reason
            }, { root: true })
        })
    },
    createScore ({ commit, rootState }) {
        return new Promise((resolve, reject) => {
            scores.createScore(state.form, rootState.axios).then(result => {
                commit('notifications/showSuccess', success.CREATE_STUDY_SUCCESS, { root: true })
                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: errors.CREATE_STUDY_ERROR, content: reason.response.data.message
                }, { root: true })
                reject(reason)
            })
        });
    },

    createScoreGroup ({ commit, rootState }) {
        return new Promise((resolve, reject) => {
            scores.createScoreGroup(state.selected_score.id, state.form_group, rootState.axios).then(result => {
                commit('setSelectedScore', result.data.score)
                commit('notifications/showSuccess', success.CREATE_STUDY_SUCCESS, { root: true })
                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: errors.CREATE_STUDY_ERROR, content: reason.response.data.message
                }, { root: true })
                reject(reason)
            })
        });
    },

    updateScore ({ commit, rootState, state}) {
        return new Promise((resolve, reject) => {
            scores.updateScore(state.selected_score.id, state.form, rootState.axios).then(result => {
                commit('setSelectedScore', result.data.score)
                commit('notifications/showSuccess', success.UPDATE_STUDY_SUCCESS, { root: true })
                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: errors.UPDATE_STUDY_ERROR, content: reason.response.data.message
                }, { root: true })
                reject(reason)
            })
        });
    },

    updateScoreGroup ({ commit, rootState, state}) {
        commit('initAllPositions')
        return new Promise((resolve, reject) => {
            scores.updateScoreGroup(state.selected_score.id, state.selected_group.id, state.form_group, rootState.axios).then(result => {
                commit('setSelectedScore', result.data.score)
                commit('notifications/showSuccess', success.UPDATE_STUDY_SUCCESS, { root: true })
                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: errors.UPDATE_STUDY_ERROR, content: reason.response.data.message
                }, { root: true })
                reject(reason)
            })
        });
    },

    loadScoreForm ({ state, commit, rootState  }) {
        scores.getScoreById(state.selected_score.id, rootState.axios).then(result => {
            commit('initScoreForm', result.data.score)
        }).catch(reason => {
            commit('notifications/showError', {
                title: errors.GET_STUDY_LOADING_ERROR, content: reason
            }, { root: true })
        })
    },

    loadScoreGroupForm ({ state, commit, rootState  }) {
        scores.getScoreGroupId(state.selected_score.id, state.selected_group.id, rootState.axios).then(result => {
            commit('initFormGroup', result.data.scoreGroup)
        }).catch(reason => {
            commit('notifications/showError', {
                title: errors.GET_STUDY_LOADING_ERROR, content: reason
            }, { root: true })
        })
    },

    postDeleteScore ({state, commit, rootState }) {
        return new Promise((resolve, reject) => {
            scores.deleteScore(state.selected_score.id, rootState.axios).then(result => {
                commit('notifications/showSuccess', success.UPDATE_STUDY_SUCCESS, { root: true })
                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: errors.UPDATE_STUDY_ERROR, content: reason
                }, { root: true })
                reject(reason)
            })
        });
    },

    postDeleteScoreGroup ({state, commit, rootState }) {
        return new Promise((resolve, reject) => {
            scores.deleteScoreGroup(state.selected_score.id, state.selected_group.id, rootState.axios).then(result => {
                commit('setSelectedScore', result.data.score)
                commit('notifications/showSuccess', success.UPDATE_STUDY_SUCCESS, { root: true })
                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: errors.UPDATE_STUDY_ERROR, content: reason
                }, { root: true })
                reject(reason)
            })
        });
    },

    addNewQuestion ({state, commit }) {
        commit('initFormQuestion')
        commit('newQuestion', state.form_question)
    },
    removeQuestion ({state, commit, rootState }, index) {
        commit('removeQuestion', index)
    },
    addNewAnswer ({state, commit }, questionIndex) {
        commit('initFormAnswer')
        commit('newAnswer', {questionIndex, answer: state.form_answer})
    },
    removeAnswer({state, commit, rootState }, questionIndex, index) {
        commit('removeAnswer', {questionIndex, index})
    },

    archive({state, commit, rootState }) {
        return new Promise((resolve, reject) => {
            scores.archive(state.selected_score.id, rootState.axios).then(result => {
                commit('notifications/showSuccess', success.UPDATE_STUDY_SUCCESS, { root: true })
                commit('setSelectedScore', result.data.score)
                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: errors.UPDATE_STUDY_ERROR, content: reason
                }, { root: true })
                reject(reason)
            })
        });
    },

    unarchive({state, commit, rootState }) {
        return new Promise((resolve, reject) => {
            scores.unarchive(state.selected_score.id, rootState.axios).then(result => {
                commit('notifications/showSuccess', success.UPDATE_STUDY_SUCCESS, { root: true })
                commit('setSelectedScore', result.data.score)
                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: errors.UPDATE_STUDY_ERROR, content: reason
                }, { root: true })
                reject(reason)
            })
        });
    }
}

// mutations
const mutations = {
    setPunctualScores (state, scores) {
        state.punctual_scores = scores
    },
    setActivePunctualScores (state, scores) {
        state.active_punctual_scores = scores
    },
    setFormType(state, value) {
        state.form.type = value
    },
    setFormName (state, value) {
        state.form.name = value
    },
    setFormInstructions (state, value) {
        state.form.instructions = value
    },
    setFormStatus (state, value) {
        state.form.status = value
    },
    setFormRule (state, value) {
        state.form.rule = value
    },
    setFormExtra (state, value) {
        state.form.extra = value
    },
    setFormIsOpposite (state, value) {
        state.form.is_opposite = value
    },
    setSelectedScore (state, value) {
        state.selected_score = value
    },
    setSelectedScoreId (state, value) {
        state.selected_score.id = value
    },
    initScoreForm (state, data) {
        if(!data){
            state.form = {
                name: '',
                nameOriginal: '',
                instructions: null,
                instructionsOriginal: '',
                type: TYPES.PUNCTUAL,
                status: null,
                rule: 'sum',
                extra: null,
                is_opposite: false,
            }
            return
        }
        state.form = {
            name: data.name,
            nameOriginal: data.nameOriginal,
            instructions: data.instructions,
            instructionsOriginal: data.instructionsOriginal,
            type: data.type,
            status: data.status,
            rule: data.rule,
            extra: data.extra,
            is_opposite: data.is_opposite,
        }

    },
    setFormGroupName (state, value) {
        state.form_group.name = value
    },
    setFormGroupInstructions (state, value) {
        state.form_group.instructions = value
    },
    setFormGroupRule (state, value) {
        state.form_group.rule = value
    },
    setFormGroupExtra (state, value) {
        state.form_group.extra = value
    },
    setFormGroupPosition (state, value) {
        state.form_group.position = value
    },
    setFormGroupConcern (state, value) {
        state.form_group.concern = value
    },

    setSelectedGroupId (state, value) {
        state.selected_group.id = value
    },

    setSelectedGroup (state, value) {
        state.selected_group = value
    },

    initFormGroup (state, data) {
        if(!data){
            state.form_group = {
                name: '',
                nameOriginal: '',
                instructions: null,
                instructionsOriginal: null,
                rule: 'sum',
                extra: null,
                position: 1,
                concern: CONCERNS.PATIENT,
                questions: [],
                can: {
                    delete: false
                }
            }
            return
        }
        state.form_group = {
            name: data.name,
            nameOriginal: data.nameOriginal,
            instructions: data.instructions,
            instructionsOriginal: data.instructionsOriginal,
            rule: data.rule,
            extra: data.extra,
            position: data.position,
            concern: data.concern,
            questions: data.questions,
            can: data.can
        }
    },
    initFormQuestion (state, data) {
        if(!data){
            state.form_question = {
                text: '',
                position: 1,
                special_type: null,
                answers: [],
                can: {
                    delete: true
                }
            }
            return
        }
        state.form_question = {
            text: data.text,
            position: data.position,
            special_type: data.special_type,
            answers: data.answers,
            can: data.can
        }
    },
    initFormAnswer (state, data) {
        if(!data){
            state.form_answer = {
                text: '',
                remarks: null,
                position: 1,
                value: null,
                can: {
                    delete: true
                }
            }
            return
        }
        state.form_answer = {
            text: data.text,
            remarks: data.remarks,
            position: data.position,
            value: data.value,
            can: data.can
        }
    },
    newQuestion(state, value) {
        state.form_group.questions.push(value)
    },
    removeQuestion(state, value) {
        state.form_group.questions.splice(value, 1)
    },

    moveUpQuestion(state, index) {
        const question = state.form_group.questions[index]

        state.form_group.questions.splice(index, 1);
        state.form_group.questions.splice(index -1, 0, question);
    },
    moveDownQuestion(state, index) {
        const question = state.form_group.questions[index]

        state.form_group.questions.splice(index, 1);
        state.form_group.questions.splice(index +1, 0, question);
    },

    moveUpAnswer(state, arg) {
        const answer = state.form_group.questions[arg.questionIndex].answers[arg.index]

        state.form_group.questions[arg.questionIndex].answers.splice(arg.index, 1);
        state.form_group.questions[arg.questionIndex].answers.splice(arg.index -1, 0, answer);
    },

    moveDownAnswer(state, arg) {
        const answer = state.form_group.questions[arg.questionIndex].answers[arg.index]
        state.form_group.questions[arg.questionIndex].answers.splice(arg.index, 1);
        state.form_group.questions[arg.questionIndex].answers.splice(arg.index +1, 0, answer);
    },
    newAnswer(state, value) {
        state.form_group.questions[value.questionIndex].answers.push(value.answer)
    },
    removeAnswer(state, value) {
        state.form_group.questions[value.questionIndex].answers.splice(value.index, 1)
    },
    setFormQuestionText (state, value) {
        state.form_group.questions[value.index].text = value.text
    },
    setFormQuestionSpecialType (state, value) {
        state.form_group.questions[value.index].special_type = value.special_type
    },
    setFormAnswerText (state, value) {
        state.form_group.questions[value.questionIndex].answers[value.index].text = value.text
    },
    setFormAnswerRemarks (state, value) {
        state.form_group.questions[value.questionIndex].answers[value.index].remarks = value.remarks
    },
    setFormAnswerValue (state, value) {
        state.form_group.questions[value.questionIndex].answers[value.index].value = value.value
    },
    initAllPositions (state) {
        state.form_group.questions.forEach((question, index) => {
            question.position = index + 1
            question.answers.forEach((answer, index) => {
                answer.position = index + 1
            })
        })
    },
    setErrors(state, value) {
        state.errors = value
    },
    setCurrentLanguage(state, value) {
        state.currentLanguage = value
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
